<div class="container mt-5">
  <div class="row justify-content-center">
    <div class="col-md-6 col-lg-4">
      <div class="card">
        <div class="card-header">
          <h4 class="mb-0">Test Login</h4>
        </div>
        <div class="card-body">
          <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
            <div class="mb-3">
              <label for="username" class="form-label">Username</label>
              <input
                type="text"
                class="form-control"
                id="username"
                formControlName="username"
                placeholder="Enter username"
                [class.is-invalid]="loginForm.get('username')?.invalid && loginForm.get('username')?.touched">
              <div class="invalid-feedback">
                Username is required
              </div>
            </div>

            <div class="mb-3">
              <label for="password" class="form-label">Password</label>
              <input
                type="password"
                class="form-control"
                id="password"
                formControlName="password"
                placeholder="Enter password"
                [class.is-invalid]="loginForm.get('password')?.invalid && loginForm.get('password')?.touched">
              <div class="invalid-feedback">
                Password is required
              </div>
            </div>

            <div class="mb-3">
              <label for="locationId" class="form-label">Location ID</label>
              <input
                type="text"
                class="form-control"
                id="locationId"
                formControlName="locationId"
                placeholder="Enter location ID"
                [class.is-invalid]="loginForm.get('locationId')?.invalid && loginForm.get('locationId')?.touched">
              <div class="invalid-feedback">
                Location ID is required
              </div>
              <small class="form-text text-muted">Default: 99998 for testing</small>
            </div>

            <div *ngIf="errorMessage" class="alert alert-danger" role="alert">
              {{ errorMessage }}
            </div>

            <div *ngIf="successMessage" class="alert alert-success" role="alert">
              <h5 class="alert-heading">Login Successful!</h5>
              <p style="white-space: pre-wrap;">{{ successMessage }}</p>

              <!-- Authentication Verification Section -->
              <div *ngIf="isVerifyingAuth" class="mt-3">
                <div class="spinner-border spinner-border-sm text-success" role="status">
                  <span class="visually-hidden">Verifying authentication...</span>
                </div>
                <span class="ms-2">Verifying authentication with getCurrentUser API...</span>
              </div>

              <!-- Current User Information from API -->
              <div *ngIf="currentUserInfo && !isVerifyingAuth" class="mt-3">
                <h6>📡 getCurrentUser API Response:</h6>
                <div class="bg-light p-2 rounded">
                  <pre class="mb-0" style="font-size: 0.85em;">{{ currentUserInfo | json }}</pre>
                </div>
              </div>

              <hr>
              <p class="mb-0">
                <button type="button" class="btn btn-success" (click)="navigateToDashboard()">
                  Go to Dashboard
                </button>
              </p>
            </div>

            <button
              type="submit"
              class="btn btn-primary w-100"
              [disabled]="isLoading">
              <span *ngIf="!isLoading">Login</span>
              <span *ngIf="isLoading">
                <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Logging in...
              </span>
            </button>
          </form>
        </div>
        <div class="card-footer text-muted text-center">
          <small>This is a test login component for development</small>
        </div>
      </div>
    </div>
  </div>
</div>